import HeaderMono from "../ui/HeaderMono";
import { education } from "../../content";

export default function Education({ sectionTint2 }) {
    return (
        <section id="education" className={`border-t border-white/5 ${sectionTint2}`}>
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <HeaderMono>Education</HeaderMono>
                <div className="space-y-6">
                    {education.map((e, i) => (
                        <div key={i} className="rounded-2xl border border-white/10 bg-white/[0.03] p-5">
                            <h3 className="font-semibold text-lg">{e.school}</h3>
                            <p className="text-slate-300 text-sm">{e.degree} — {e.dates}</p>
                            {e.detail && <p className="text-slate-400 text-sm mt-2">{e.detail}</p>}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
